import { Injectable } from '@angular/core';


@Injectable()
export class CustomArrayOpsService {

    /* A Binary Search based function to find
    index of FIRST occurrence of x in arr[].
    If x is not present, then it returns -1 */
    first(arr, low, high, x, n) {
        if (high >= low) {
            // (low + high)/2; 
            let mid = low + Math.floor((high - low) / 2);

            if ((mid == 0 || x > arr[mid - 1]) && arr[mid] == x)
                return mid;
            if (x > arr[mid])
                return this.first(arr, (mid + 1), high, x, n);
            return this.first(arr, low, (mid - 1), x, n);
        }
        return -1;
    }

    // Sort A1[0..m-1] according to the order
    // defined by A2[0..n-1].
    sortAccording(A1, A2) {

        let m = A1.length;
        let n = A2.length;

        // The temp array is used to store a copy
        // of A1[] and visited[] is used to mark the
        // visited elements in temp[].
        let temp = [];
        let visited = [];

        for (let i = 0; i < m; i++) {
            temp[i] = A1[i];
            visited[i] = 0;
        }

        // Sort elements in temp
        temp.sort(function (a, b) { return a - b });

        // for index of output which is sorted A1[]
        let ind = 0;

        // Consider all elements of A2[], find them
        // in temp[] and copy to A1[] in order.
        for (let i = 0; i < n; i++) {
            // Find index of the first occurrence
            // of A2[i] in temp
            let f = this.first(temp, 0, m - 1, A2[i], m);
            // If not present, no need to proceed
            if (f == -1) {
                continue;
            }
            // Copy all occurrences of A2[i] to A1[]
            for (let j = f; (j < m && temp[j] == A2[i]); j++) {
                A1[ind++] = temp[j];
                visited[j] = 1;
            }
        }
        // Now copy all items of temp[] which are
        // not present in A2[]
        for (let i = 0; i < m; i++) {
            if (visited[i] == 0)
                A1[ind++] = temp[i];
        }

    }

    /* A Binary Search based function to find
    index of FIRST occurrence of x in arr[{prop: x}].
    If x is not present, then it returns -1 */
    /**
     * 
     * @param arr 
     * @param prop: property name whose value is x
     * @param low 
     * @param high 
     * @param x 
     * @param n 
     * @returns 
     */
    firstInObjArr(arr, prop, low, high, x, n) {
        if (high >= low) {
            // (low + high)/2; 
            let mid = low + Math.floor((high - low) / 2);

            if ((mid == 0 || x > arr[mid - 1][prop]) && arr[mid][prop] == x)
                return mid;
            if (x > arr[mid][prop])
                return this.firstInObjArr(arr, prop, (mid + 1), high, x, n);
            return this.firstInObjArr(arr, prop, low, (mid - 1), x, n);
        }
        return -1;
    }

    // Sort A1[0..m-1] according to the order
    // defined by A2[0..n-1].
    /**
     * Method sorting an array (A1) of objects based on a property
     * The order of sorting is derived from another array (A2)
     * @param A1 : Array to be sorted
     * @param A2 : Array defining the order of sorting
     * @param prop : property name based on which the sorting has to be performed
     */
    sortObjArrAccording(A1, A2, prop) {

        let m = A1.length;
        let n = A2.length;

        // The temp array is used to store a copy
        // of A1[] and visited[] is used to mark the
        // visited elements in temp[].
        let temp = [];
        let visited = [];

        for (let i = 0; i < m; i++) {
            temp[i] = A1[i];
            visited[i] = 0;
        }

        // Sort elements in temp
        temp.sort((a, b) => {
            if (a[prop] < b[prop]) {
                return -1;
            }
            if (a[prop] > b[prop]) {
                return 1;
            }
            return 0;
        });

        // for index of output which is sorted A1[]
        let ind = 0;

        // Consider all elements of A2[], find them
        // in temp[] and copy to A1[] in order.
        for (let i = 0; i < n; i++) {
            // Find index of the first occurrence
            // of A2[i] in temp
            let f = this.firstInObjArr(temp, prop, 0, m - 1, A2[i], m);
            // If not present, no need to proceed
            if (f == -1) {
                continue;
            }
            // Copy all occurrences of A2[i] to A1[]
            for (let j = f; (j < m && temp[j][prop] == A2[i]); j++) {
                A1[ind++] = temp[j];
                visited[j] = 1;
            }
        }
        // Now copy all items of temp[] which are
        // not present in A2[]
        for (let i = 0; i < m; i++) {
            if (visited[i] == 0)
                A1[ind++] = temp[i];
        }

        return A1;
    }

}